var settings = {
  api_headers: {
    Accept: 'application/vnd.com.soampli-v1.0+json'
  },
  preview_key: '9949dec78e88482a9d411daaaf128a0a'
};

export default settings;
